<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          Confirm Delete Blog Post
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to delete this Blog Post?
          </div>
          <div v-if="blogpost" class="mt-4">
            <div class="mb-2">
              <strong>Author Name:</strong>
              {{ blogpost.blog_author_name || "-" }}
            </div>

            <div>
              <strong>Status:</strong>
              {{ blogpost.blog_status || "-" }}
            </div>
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            This action cannot be undone.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="error" variant="flat" @click="handleDelete" :loading="loading">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { generateClient } from "aws-amplify/api";
import { edit_blog } from "@/graphql/mutations";
const client = generateClient();
export default {
  name: "DeleteBlogPostDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    blogpost: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      if (!this.blogpost?.blog_id) {
        return;
      }

      this.loading = true;
      try {
        // Using edit mutation to set status to DEACTIVE as delete placeholder
        const input = {
          blog_id: this.blogpost.blog_id,
          blog_status: "DEACTIVE",
        };

        const response = await client.graphql({
          query: edit_blog,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.edit_blog);
        // console.log(responseData);

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Blog Post deleted successfully!",
            color: "success",
          };
          this.dialog = false;
          this.$emit("deleted");
        } else {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to delete Blog Post",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error deleting blogpost:", error);
        this.snackbar = {
          show: true,
          message: (error.errors && error.errors[0]?.message) || error.message || "An error occurred while deleting Blog Post",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
